<template>
  <div id="app">
    <layoutTopbar></layoutTopbar>

    <component v-if="this.$store.getters.indication[this.$route.path] && hasIndication" :is="whichIndication" />

    <el-container class="u-flex-col">
      <el-container>
        <layoutAside></layoutAside>
        <el-container class="wrapper">
          <div @click="toTop" class="to-top"></div>

          <layoutHeader></layoutHeader>
          <slot v-if="hasLogin" />
          <layoutCheckLogin v-else></layoutCheckLogin>
        </el-container>
      </el-container>
      <layoutFooter></layoutFooter>
    </el-container>
  </div>
</template>

<script>
import IndicationMixin from '@/components/indication'

import layoutTopbar from '@/components/layout/layout-topbar'
import layoutAside from '@/components/layout/layout-aside'
import layoutHeader from '@/components/layout/layout-header'
import layoutFooter from '@/components/layout/layout-footer'
import layoutCheckLogin from '@/components/layout/layout-check-login'


import InitMixin from './initMixin'
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters(['hasLogin']),
  },
  mixins: [InitMixin, IndicationMixin],
  methods: {
    toTop() {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    },
  },

  components: {
    layoutTopbar,
    layoutHeader,
    layoutAside,
    layoutFooter,
    layoutCheckLogin
  },
}
</script> 
 
<style  lang="stylus"  scoped="scoped">
.wrapper {
  min-height: 100vh;
  $toTopSide = 70px;

  .to-top {
    width: $toTopSide;
    height: $toTopSide;
    position: absolute;
    cursor: pointer;
    right: 0;
    bottom: 0;
    background-image: url('../assets/img/2top.png');
    background-size: $toTopSide $toTopSide;
  }

  $toTopSide;
  position: relative;
  width: 100%;
  display: flex;
  padding-bottom: $toTopSide;
  flex-direction: column;
}
</style>
